<template>
  <div>
    <v-row align="center" justify="center">
      <v-col lg="4" md="4" cols="12">
        <RadialProgress :diameter="120" :animateSpeed="1000" :innerStrokeWidth="5" :strokeWidth="3" :completed-steps="seconds" :total-steps="totalSteps">
          <p class="pt-2">{{ timerOutput }}</p>
        </RadialProgress>
        
      </v-col>
      <v-col lg="8" md="8" cols="12">
        <p class="pt-2">{{ message }}</p>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { ProjectMessages } from "../../definitions/constants";
import RemainingDate from "../../models/RemainingDate";
import Utils from "../../utils/Utils";
import Vue, { defineComponent } from "vue";
import RadialProgress from "vue3-radial-progress";

export default defineComponent({
  props: ["fromDate", "addressVerificaion", "phoneNumberVerification", "totalSeconds"],
  components: {
    RadialProgress
  },
  data() {
    return {
      totalSteps: 0,
      from: 0,
      to: 0,
      timerOutput: "",
      timer: 0,
      seconds: 0,
      message: "",
    };
  },
  methods: {
    startTimer: function () {
      const toDate = new Date();
      const timeDifference = this.fromDate - toDate.getTime();
      this.seconds = Math.abs(timeDifference) / 1000;
      if (!this.fromDate) {
        clearInterval(this.timer);
      }
      var remainigDate = Utils.getRemainingDateByTimeDifference(timeDifference) as RemainingDate;
      if (this.addressVerificaion) {
        const remainingDays = remainigDate.Day;
        const remainingHours = remainigDate.Hour;
        this.timerOutput = `${remainingDays} Days`;
      }
      if (this.phoneNumberVerification) {
        this.timerOutput = `${remainigDate.Minute * 60 + remainigDate.Second}`;
      }
      if (timeDifference <= 0) {
        clearInterval(this.timer);
        this.$emit("finishCountdownTimer", { isAddress: this.addressVerificaion, isPhoneNumber: this.phoneNumberVerification });
        this.timerOutput = ProjectMessages.timeOver;
        this.message = ProjectMessages.verificationTimeOver;
      }
    },
  },
  mounted() {
    this.totalSteps = this.totalSeconds;
    this.timer = window.setInterval(() => {
      this.startTimer();
    }, 1000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
});
</script>
